import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export const fetchNews = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/news`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const deleteNew = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.delete(`/news/${data.id}`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const fetchNew = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/news/${data.id}`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const putNew = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(`/news/${data.id}`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const postNew = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.post(`/news`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};
